import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './SerialNumbers.frontend.types'

@Injectable({ providedIn: 'root' })
export class SerialNumbers_update_serial_numbers_flowService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { serial_numbers: { id: number, properties: $frontendTypes.SerialNumbers.SerialNumber }[] }): Promise<{ reasons?: string[], results?: { succeeded?: number, failed?: number, duration?: number } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.serial_numbers)) {
      missingRequiredInParams.push('\'serial_numbers\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SerialNumbers/functions/update_serial_numbers_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

